import { accessEngineApi } from '@ctct/infrastructure-layer';

class AccessEngineRepo {
  public async invalidateCache() {
    await accessEngineApi.deleteCache();
  }
}

export const accessEngineRepo = new AccessEngineRepo();
